import React from 'react'
import { useCmsPageByPath } from 'lib/core/hooks'
import { Slider } from './components/Slider'
import { FindSolution } from './components/FindSolution'
import { Brands } from './components/Brands'
import { FeaturedCategories } from './components/FeaturedCategories'
import { FeaturedPosts } from './components/FeaturedPosts'
import { Community } from './components/Community'
import { Reviews } from './components/Reviews'
import { MetaData } from 'components/MetaData'
import { FeaturedProducts } from './components/FeaturedProducts'
import { Container, Wrapper } from './styled'

export const Home = () => {
  const { title, meta_description: metaDescription, meta_title: metaTitle } = useCmsPageByPath('home')
  return (
    <Container>
      <MetaData
        title={title ?? metaTitle}
        description={metaDescription}
      />
      <Wrapper>
        <Slider />
        <Brands />
        <FeaturedProducts />
        <Reviews />
        <FeaturedCategories />
      </Wrapper>
      <FindSolution />
      <Community />
      <FeaturedPosts />
    </Container>
  )
}
